import * as React from 'react';

function Pubs(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={22} height={17} viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.875.375H3.125a2.243 2.243 0 00-2.25 2.25v11.25c0 1.266.984 2.25 2.25 2.25h15.75c1.23 0 2.25-.984 2.25-2.25V2.625c0-1.23-1.02-2.25-2.25-2.25zM7.062 3.75c1.231 0 2.25 1.02 2.25 2.25 0 1.266-1.019 2.25-2.25 2.25A2.221 2.221 0 014.813 6c0-1.23.985-2.25 2.25-2.25zm3.375 9h-6.75a.555.555 0 01-.562-.563 2.798 2.798 0 012.813-2.812h2.25A2.82 2.82 0 0111 12.188a.578.578 0 01-.563.562zm7.876-2.25h-4.5a.555.555 0 01-.563-.563c0-.28.246-.562.563-.562h4.5c.28 0 .562.281.562.563a.578.578 0 01-.563.562zm0-2.25h-4.5a.555.555 0 01-.563-.563c0-.28.246-.562.563-.562h4.5c.28 0 .562.281.562.563a.578.578 0 01-.563.562zm0-2.25h-4.5a.555.555 0 01-.563-.563c0-.28.246-.562.563-.562h4.5c.28 0 .562.281.562.563a.578.578 0 01-.563.562z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Pubs;
